import React from 'react';

const Container = ({ children, className = '', size = 'default', as: Component = 'div' }) => {
  const maxWidths = {
    narrow: 'max-w-3xl',
    default: 'max-w-7xl',
    wide: 'max-w-[90rem]',
    full: 'max-w-full',
  };

  return (
    <Component className={`${maxWidths[size]} mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </Component>
  );
};

export default Container;
